import CookieManager from '@react-native-cookies/cookies';

import { TLang } from '@webtrader/core/i18n';

import { configService } from '../services/config';

export enum ENativeCookieName {
  LANG = 'lang'
}

export type NativeCookieKeyValueList = {
  [ENativeCookieName.LANG]: TLang;
};

const setValue = async <CookieName extends keyof NativeCookieKeyValueList>(
  name: CookieName,
  value: NativeCookieKeyValueList[CookieName]
) => {
  CookieManager.set(
    configService.getCurrentApiDomain(),
    {
      name,
      path: '/',
      value
    },
    true
  );
};

const getValue = async <CookieName extends keyof NativeCookieKeyValueList>(name: CookieName) => {
  const cookies = await CookieManager.get(configService.getCurrentApiDomain(), true);

  return cookies[name]?.value as NativeCookieKeyValueList[CookieName] | undefined;
};

export default { setValue, getValue };
